import {useMemo} from 'react';

import {useRouter} from 'next/router';

const useIsEmbedPages = () => {
  const route = useRouter();

  const isEmbed = useMemo(
    () => !!route?.asPath?.startsWith('/embed'),
    [route?.asPath],
  );

  return isEmbed;
};

export default useIsEmbedPages;
